import FilterMenu from './FilterMenu';

export { FilterMenu };



// WEBPACK FOOTER //
// ./src/components/FilterMenu/index.ts